import React, {useState} from "react";
import styled from "styled-components";
import tw from "twin.macro";
import Letter from "./Letter";

const BoardContainer = styled.div`
  min-width: 320px;

  ${tw`
    w-full
    h-full
    flex
    justify-center
    items-center

    `}
`
const BoardStyle = styled.div`
  ${tw`
  h-auto
  flex
  flex-shrink
  justify-center
  grid  
    `}
`
const Row = styled.div`
  ${tw`
  grid
  grid-cols-5
    
    `}
`


export default function Board() {

    return (
        <>
            <BoardContainer>
                <BoardStyle>
                    <Row>
                            <Letter letterPos={0} attemptVal={0} />
                            <Letter letterPos={1} attemptVal={0} />
                            <Letter letterPos={2} attemptVal={0} />
                            <Letter letterPos={3} attemptVal={0} />
                            <Letter letterPos={4} attemptVal={0} />
                    </Row>
                    <Row>
                            <Letter attemptVal={1} letterPos={0} />
                            <Letter attemptVal={1} letterPos={1} />
                            <Letter attemptVal={1} letterPos={2} />
                            <Letter attemptVal={1} letterPos={3} />
                            <Letter attemptVal={1} letterPos={4} />
                    </Row>
                    <Row>
                            <Letter attemptVal={2} letterPos={0} />
                            <Letter attemptVal={2} letterPos={1} />
                            <Letter attemptVal={2} letterPos={2} />
                            <Letter attemptVal={2} letterPos={3} />
                            <Letter attemptVal={2} letterPos={4} />
                    </Row>
                    <Row>
                            <Letter attemptVal={3} letterPos={0} />
                            <Letter attemptVal={3} letterPos={1} />
                            <Letter attemptVal={3} letterPos={2} />
                            <Letter attemptVal={3} letterPos={3} />
                            <Letter attemptVal={3} letterPos={4} />
                    </Row>
                    <Row>
                            <Letter attemptVal={4} letterPos={0} />
                            <Letter attemptVal={4} letterPos={1} />
                            <Letter attemptVal={4} letterPos={2} />
                            <Letter attemptVal={4} letterPos={3} />
                            <Letter attemptVal={4} letterPos={4} />
                    </Row>
                    <Row>
                            <Letter attemptVal={5} letterPos={0} />
                            <Letter attemptVal={5} letterPos={1} />
                            <Letter attemptVal={5} letterPos={2} />
                            <Letter attemptVal={5} letterPos={3} />
                            <Letter attemptVal={5} letterPos={4} />
                    </Row>
                </BoardStyle>
            </BoardContainer>
        </>
    )
}
